/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var maxHeight = MoyaContainer.get('core.max-height');
    MoyaComponents.register('store.buy-x-get-y', function (el) {
        var amount = el.dataset.amountToTrigger;
        var component = new BuyYGetX(Number(amount));
        component.run();
    });
    var NOT_SHOW = 'not_show';
    var BuyYGetX = /** @class */ (function () {
        function BuyYGetX(amount) {
            this.amount = amount;
        }
        BuyYGetX.prototype.run = function () {
            this.updateQtyWrap();
            this.checkForQtySelectUpdate();
        };
        BuyYGetX.prototype.updateQtyWrap = function () {
            var qtyWrap = document.querySelector('.buyBox .qtyWrap');
            var qtyInfo = document.createElement('div');
            qtyInfo.classList.add(NOT_SHOW);
            qtyInfo.classList.add('buyXgetY');
            qtyInfo.innerText = 'Þú færð 1 frítt!';
            qtyWrap.append(qtyInfo);
            maxHeight.init('.buyXgetY');
        };
        BuyYGetX.prototype.checkForQtySelectUpdate = function () {
            var _this = this;
            util.delegate(document.querySelector('#qty'), 'change', '.select.qty', function (e) {
                var target = e.target;
                var numberOfFree = Math.floor(Number(target.value) / _this.amount);
                var qtyInfo = document.querySelector('.buyXgetY');
                if (numberOfFree > 0) {
                    qtyInfo.classList.remove(NOT_SHOW);
                    qtyInfo.innerText = 'Þú færð ' + numberOfFree + ' frítt!';
                }
                else {
                    qtyInfo.classList.add(NOT_SHOW);
                }
            });
        };
        return BuyYGetX;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
